import { useEffect } from "react";
import useStore from "core/custom-hooks/useStore";
import mobileAppEventType from "core/common/types/mobileAppEventType";
import { setIsMobileApp, setMobileAppWrapperData, setOtp, setHash } from "core/store/actionCreators";

const useMobileAppEvents = () => {
    const { dispatch, state } = useStore();
    const { globalEventEmitter } = state;

    const handleMessage = (event) => {
        const { data } = event;
        if (typeof (data) !== "string") return;

        let messageObj = null;
        try {
            messageObj = JSON.parse(data);
        } catch (e) {
            return;
        }

        const { type } = messageObj || {};
        if (!messageObj instanceof Object || !type || !mobileAppEventType[type]) return;
        const { payload } = messageObj;

        switch (type) {
            case mobileAppEventType.generalMessage:
                const { message } = payload || {};
                if (message) {
                    alert(`***** React alert! *****: ${message}`);
                }
                break;
            case mobileAppEventType.sensorAvailable:
                dispatch(setMobileAppWrapperData({ hebrewBiometryType: payload.hebrewBiometryType, isAndroid: payload.isAndroid }));
                break;
            case mobileAppEventType.sensorAvailableAndEnabled:
                dispatch(setMobileAppWrapperData({ hebrewBiometryType: payload.hebrewBiometryType, isAndroid: payload.isAndroid, isBiometricLoginEnabled: true }));
                break;
            case mobileAppEventType.loginData:
                dispatch(setMobileAppWrapperData({ isBiometricLoginEnabled: true }));
                const { email, password, callBack } = payload;
                if(callBack){
                    globalEventEmitter.emit(type, { email, password });
                }
                break;
            case mobileAppEventType.getOtp:
                const { otp } = payload;
                dispatch(setOtp(otp));
                break;  
            case mobileAppEventType.getHash:
                const { hash } = payload;
                dispatch(setHash(hash[0]));
                break;       
        }
    };

    const emit = (type, data = {}) => window.ReactNativeWebView?.postMessage(JSON.stringify({
        type,
        payload: {
            ...data
        }
    }));

    const emitMobileMessage = (type, data = {}) => {
        if (!type || !mobileAppEventType[type]) return;

        switch (type) {
            case mobileAppEventType.generalMessage:
                if (typeof (data) === "object") {
                    emit(type, { title: data.title, message: data.message });
                }
                break;
            case mobileAppEventType.showSensor:
                emit(type);
                break;
             case mobileAppEventType.mailTo:
                    emit(type,{mail:data.mail});
                    break;
             case mobileAppEventType.sendWhatsapp:
                    emit(type,{phoneNumber:data.phoneNumber});
                    break;
            case mobileAppEventType.biometricsRegistration:
                emit(type, { email: data.email, password: data.password, callBack:data.callBack });
                break;
            case mobileAppEventType.biometricsDisabling:
                emit(type, {});
                break;
            case mobileAppEventType.base64Download:
                emit(type, { base64: data.base64, extension: data.extension, hebrewDescription: data.hebrewDescription, fileName: data.fileName, mime: data.mime });
                break;
        }
    };

    useEffect(() => {
        const isMobileApp = window.navigator.userAgent?.includes("@@@MobileWrapper@@@");
        if (!isMobileApp) return;
        const isAndroid = !window.navigator.userAgent?.includes("appleapp");

        dispatch(setMobileAppWrapperData({ mobileEventEmitter: emitMobileMessage }));
        dispatch(setIsMobileApp(true));
        if (isAndroid) {
            document.addEventListener("message", handleMessage);
        } else {
            window.addEventListener("message", handleMessage);
        }

        return () => {
            if (isAndroid) {
                document.removeEventListener("message", handleMessage);

            } else {
                window.removeEventListener("message", handleMessage);
            }
        };
    }, []);
};

export default useMobileAppEvents;
